import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import '../css/Fondo.css';

const PanelDeControl = () => {
    const navigate = useNavigate();
    const [userId, setUserId] = useState(null);
    const [tokenId, setTokenId] = useState(null);

    useEffect(() => {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
            setUserId(user.uid);
            user.getIdToken().then((idToken) => {
                setTokenId(idToken);
            }).catch((error) => {
                console.error('Error fetching ID token:', error);
            });
        }
    }, []);

    const buttonStyle = {
        backgroundColor: '#4CAF50',
        border: 'none',
        color: 'white',
        padding: '12px 24px',
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: '20px',
        margin: '10px',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease, transform 0.2s ease',
        transform: 'scale(1.00)',
    };

    const hoverStyle = {
        backgroundColor: '#45a049',
        transform: 'scale(1.05)',
    };

    return (
        <div className="divoverflow">
            <div className="ltm-fondo-crema fondo-padding d-flex flex-column align-items-center text-center divfill">
                <div
                    style={{
                        display: 'inline-block',
                        textAlign: 'center',
                        fontSize: 'clamp(2rem, 4vw, 7rem)',
                        fontWeight: 'bold',
                        color: '#333',
                    }}
                >
                    Panel de Control
                </div>
                <br />
                <button
                    style={{ ...buttonStyle, backgroundColor: '#008CBA' }}
                    onMouseEnter={(e) =>
                        Object.assign(e.target.style, {
                            backgroundColor: '#007BB5',
                            transform: 'scale(1.05)',
                        })
                    }
                    onMouseLeave={(e) =>
                        Object.assign(e.target.style, {
                            backgroundColor: '#008CBA',
                            transform: 'scale(1)',
                        })
                    }
                    onClick={() => navigate('/imagebackend')}
                >
                    Administrar Banner Principal
                </button>
                <button
                    style={{ ...buttonStyle, backgroundColor: '#FFA500' }}
                    onMouseEnter={(e) =>
                        Object.assign(e.target.style, {
                            backgroundColor: '#E68900',
                            transform: 'scale(1.05)',
                        })
                    }
                    onMouseLeave={(e) =>
                        Object.assign(e.target.style, {
                            backgroundColor: '#FFA500',
                            transform: 'scale(1)',
                        })
                    }
                    onClick={() => navigate('/administradorEventos')}
                >
                    Administrar Eventos
                </button>
                <button
                    style={{ ...buttonStyle, backgroundColor: '#800080' }}
                    onMouseEnter={(e) =>
                        Object.assign(e.target.style, {
                            backgroundColor: '#6A006A',
                            transform: 'scale(1.05)',
                        })
                    }
                    onMouseLeave={(e) =>
                        Object.assign(e.target.style, {
                            backgroundColor: '#800080',
                            transform: 'scale(1)',
                        })
                    }
                    onClick={() => navigate('/administradorRestoyBar')}
                >
                    Administrar Gastronomía
                </button>
            </div>
        </div>
    );
};

export default PanelDeControl;
